<ng-template #modal let-confirmModal>
  <div class="modal-header">
    <h2 class="modal-title">{{ 'sales_rep.customer_switch.modal.title' | translate }}</h2>
    <button type="button" class="close" title="Close" aria-label="Close" (click)="hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p [innerHTML]="'sales_rep.customer_switch.modal.confirmation_message' | translate : { '0': customerName }"></p>
    <div class="alert alert-warning">
      <i class="fas fa-exclamation-triangle" aria-hidden="true"></i>
      {{ 'sales_rep.customer_switch.modal.warning_message' | translate }}
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="confirmSwitch()" data-testing-id="switch-customer-confirm">
      {{ 'sales_rep.customer_switch.modal.confirm_button' | translate }}
    </button>
    <button type="button" class="btn btn-secondary" (click)="hide()" data-testing-id="switch-customer-cancel">
      {{ 'sales_rep.customer_switch.modal.cancel_button' | translate }}
    </button>
  </div>
</ng-template>
